import PropTypes from 'prop-types';

function CompanySiteFooter({ company }) {
  const logoUrl = company?.logoUrl || '/logo.svg';
  const companyName = company?.name || 'Company';

  return (
    <footer className="company-site-footer">
      <div className="company-site-footer-inner">
        <img
          src={logoUrl}
          alt={companyName}
          className="company-site-footer-logo"
          onError={(e) => {
            const img = e.target;
            if (img) img.src = '/logo.svg';
          }}
        />
        <p>© {new Date().getFullYear()} {companyName}. All rights reserved.</p>
      </div>
    </footer>
  );
}

CompanySiteFooter.propTypes = {
  company: PropTypes.shape({
    name: PropTypes.string,
    logoUrl: PropTypes.string,
  }),
};

CompanySiteFooter.defaultProps = {
  company: null,
};

export default CompanySiteFooter;
